<template>
  <div class="item h-100">
    <div class="header">
      <i class="material-icons main-icon">{{icon}}</i>
      <h1>{{label}}</h1>
      <i @click="onClickOnHelp()" class="material-icons info-icon hide-print">help_outline</i>
      <p class="only-print"></p>
    </div>
    <div class="list">
      <CanvasItemList @onDelete="onDelete" :items="items"></CanvasItemList>
    </div>
    <CanvasItemInput :buttonBackgroundColor="buttonBackgroundColor" @submit="onSubmit" :visible="true"></CanvasItemInput>
  </div>
</template>

<script>
import CanvasItemInput from "./CanvasItemInput.vue";
import CanvasItemList from "./CanvasItemList.vue";

export default {
  name: "bmcanvas-list",
  props: ["label", "icon", "items", "buttonBackgroundColor"],
  mounted() {
  },
  data() {
    return {
      isMouseOver: false,
    };
  },
  methods: {
    onSubmit(label) {
      this.$emit('created', label);
    },
    onDelete(index) {
      this.$emit('deleted', index);
    },
    onClickOnHelp() {
      this.$emit('onClickOnHelp');
    }
  },
  components: {
    CanvasItemInput,
    CanvasItemList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.header {
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  i.main-icon {
    min-width: 60px;
    text-align: center;
  }
  i.info-icon {
    padding: 0 0 0 10px;
    color: #999;
    &:hover {
      cursor:pointer;
    }
  }
  h1 {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 300;
    margin: 10px 0;
  }
  .bmc-canvas__item-input {
    min-width: 60px;
  }
}
.list {
  padding: 15px;
  height: calc
}
</style>



// WEBPACK FOOTER //
// src/components/CanvasItem.vue